var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup524(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.961,
    height: 15.94,
    viewBox: "0 0 15.961 15.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(-460.643 -367.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M474.841,372.551h0l-7.159,7.16a1.633,1.633,0,0,1-.64.392l-2.541.848a1.365,1.365,0,0,1-.858,0,1.355,1.355,0,0,1-.86-1.715l.849-2.548a1.628,1.628,0,0,1,.392-.634l7.886-7.887h-9.736a1.531,1.531,0,0,0-1.531,1.531v11.841a1.532,1.532,0,0,0,1.531,1.532H473.88a1.533,1.533,0,0,0,1.531-1.532V371.98Z",
    transform: "translate(0 0.061)",
    fill: "#586973",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M476.253,368.761a.545.545,0,0,1,0,.768l-1.137,1.138-2.18-2.18,1.137-1.137a.545.545,0,0,1,.771,0l1.409,1.408Zm-1.908,2.676-2.179-2.18-7.424,7.425a.552.552,0,0,0-.133.214l-.877,2.63a.271.271,0,0,0,.173.344.263.263,0,0,0,.171,0l2.63-.877a.54.54,0,0,0,.214-.131l7.424-7.425Z",
    transform: "translate(0.193 0)",
    fill: "#586973"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup524);
export default __webpack_public_path__ + "static/media/Group 524.784b1b74.svg";
export { ForwardRef as ReactComponent };